import { SurveyPage } from '@live-webinar/view';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/survey'].update({
        staticData: { title: { page: 'EditSurvey.Pageheading', forWebinar: true } },
        component: authGuard(SurveyPage)
    });
};
